import Vue from 'vue'
import VueRouter from 'vue-router'
import businessCenterRouter from '@/views/business-center/routers/router'
import { beforeEachFunction } from './rewrite-route.js'
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err)
}
Vue.use(VueRouter)

const routes = [
  // {
  //   path: "/",
  //   name: "Home",
  //   component: Home
  // },
  {
    path: '*',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/About.vue'),
    meta: {
      title: 'Wegymer 健萌'
    }
  },
  {
    path: '/subscribe',
    name: 'subscribe',
    component: () => import('@/views/appointment/subscribe.vue'),
    meta: {
      title: '课程预约',
      desc: '健萌',
      keepAlive: true,
      location: true, //是否获取地理位置
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
    // children: [
    //   {
    //     path: 'detail',
    //     component: (res) => require(['@/views/appointment/detail.vue'], res),
    //     props: (route) => ({
    //       detailData: route.query.detailData,
    //       currDay: route.query.currDay
    //     }),
    //     meta: {
    //       webview: {
    //         toolsBarBgColor: '#00000000',
    //         statusColor: '#00000000',
    //         isTransparentBottomBar: 1,
    //         titleColor: '#ffffff',
    //         isShowToolsBar: false
    //       }
    //     }
    //   }
    // ]
  },
  {
    path: '/subscribe/detail',
    name: 'subscribe/detail',
    component: () => import('@/views/appointment/detail.vue'),
    meta: {
      title: '课程预约',
      desc: '健萌',
      location: true, //是否获取地理位置
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/trans-coach-course',
    name: 'trans-coach-course',
    component: () => import('@/views/appointment/trans-coach-course.vue'),
    meta: {
      title: '课程预约', // 教练主页中转
      desc: '健萌',
      location: true //是否获取地理位置
    }
  },
  {
    path: '/fat-reduction',
    name: 'fat-reduction',
    component: () => import('@/views/appointment/fat-reduction.vue'),
    meta: {
      title: '课程预约',
      desc: '健萌',
      location: true //是否获取地理位置
    }
  },
  {
    path: '/reservations',
    name: 'reservations',
    component: () => import('@/views/appointment/reservations.vue'),
    meta: {
      title: '预约成功',
      desc: '健萌',
      location: true, //是否获取地理位置\
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/course-history',
    name: 'course-history',
    component: () => import('@/views/appointment/course-history.vue'),
    meta: {
      title: '课程历史',
      desc: '健萌',
      location: true //是否获取地理位置
    }
  },
  {
    path: '/course-info',
    name: 'course-info',
    component: () => import('@/views/appointment/course-info.vue'),
    meta: {
      title: '课程详情',
      desc: '健萌',
      location: true //是否获取地理位置
    }
  },
  {
    path: '/scancode',
    name: 'scancode',
    component: () => import('@/views/scancode/scancode.vue'),
    meta: {
      title: '课程详情',
      desc: '健萌',
      location: true //是否获取地理位置
    }
  },
  {
    path: '/BMICount',
    name: 'BMICount',
    component: () => import('@/views/BMICount/BMICount.vue'),
    meta: {
      title: 'BMI计算'
    }
  },
  {
    path: '/nearby-shop',
    name: 'nearby-shop',
    component: (res) => require(['@/views/nearby-shop/nearby-shop.vue'], res),
    meta: {
      title: '门店列表',
      desc: '健萌',
      location: true, //是否获取地理位置
      keepAlive: true,
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/nearby-shop-details',
    name: 'nearby-shop-details',
    component: (res) =>
      require(['@/views/nearby-shop/nearby-shop-details'], res),
    meta: {
      title: '门店详情',
      desc: '健萌',
      location: true, //是否获取地理位置
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/nearby-shop-group',
    name: 'nearby-shop-group',
    component: (res) => require(['@/views/nearby-shop/nearby-shop-group'], res),
    meta: {
      desc: '健萌',
      title: '门店团队' // 公众号版
    }
  },
  {
    path: '/my-coach-team',
    name: 'my-coach-team',
    component: (res) =>
      require(['@/views/member-center/my-coach-team/my-coach-team'], res),
    meta: {
      desc: '健萌',
      title: '我的私教',
      keepAlive: true
    }
  },
  {
    path: '/coach-wxwork-card',
    name: 'coach-wxwork-card',
    component: (res) =>
      require([
        '@/views/member-center/coach-wxwork-card/coach-wxwork-card'
      ], res),
    meta: {
      desc: '健萌',
      title: '教练名片',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/newoutline',
    name: 'newoutline',
    component: (res) => require(['@/views/newoutline/newoutline'], res),
    meta: {
      title: '训练大纲',
      desc: '健萌',
      location: true //是否获取地理位置
    }
  },
  {
    path: '/newoutlineshow',
    name: 'newoutlineshow',
    component: (res) => require(['@/views/newoutline/newoutlineshow'], res),
    meta: {
      desc: '健萌',
      title: '训练大纲'
    }
  },
  {
    path: '/newplanshow',
    name: 'newplanshow',
    component: (res) => require(['@/views/newoutline/newplanshow'], res),
    meta: {
      desc: '健萌',
      title: '训练计划'
    }
  },
  {
    path: '/gym-calendar',
    name: 'gym-calendar',
    component: (res) => require(['@/views/gym-calendar/gym-calendar'], res),
    meta: {
      title: '训练日历',
      desc: '健萌',
      location: true //是否获取地理位置
    }
  },
  {
    path: '/training-pro',
    name: 'training-pro',
    component: (res) => require(['@/views/training-project/training-pro'], res),
    meta: {
      title: '训练评估',
      desc: '健萌',
      location: true //是否获取地理位置
    }
  },
  {
    path: '/training-pro-overview',
    name: 'training-pro-overview',
    component: (res) =>
      require(['@/views/training-project/training-pro-overview'], res),
    meta: {
      title: '训练评估',
      desc: '健萌',
      location: true //是否获取地理位置
    }
  },
  {
    path: '/training-trend',
    name: 'training-trend',
    component: (res) =>
      require(['@/views/training-project/training-trend'], res),
    meta: {
      title: '体测记录',
      desc: '健萌',
      location: true //是否获取地理位置
    }
  },
  {
    path: '/outline-preview',
    name: 'outline-preview',
    component: () => import('@/views/newoutline/outline-preview.vue'),
    meta: {
      desc: '健萌',
      title: '训练大纲'
    }
  },
  {
    path: '/training-plan-show',
    name: 'training-plan-show',
    component: (res) => require(['@/views/newoutline/training-plan-show'], res),
    meta: {
      desc: '健萌',
      title: '训练计划'
    }
  },
  {
    path: '/course-plan-show',
    name: 'course-plan-show',
    component: (res) => require(['@/views/newoutline/course-plan-show'], res),
    meta: {
      desc: '健萌',
      tips: '当前课程训练计划展示',
      title: '训练计划'
    }
  },
  {
    path: '/activity-project',
    name: 'activity-project',
    component: (res) =>
      require(['@/views/activity/2025/activity-project/activity-project'], res),
    meta: {
      desc: '健萌',
      title: 'Project挑战',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/test-upload',
    name: 'test-upload',
    component: (res) =>
      require(['@/views/activity/2025/activity-project/test-upload'], res),
    meta: {
      desc: '健萌',
      title: 'Project挑战',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },

  {
    path: '/app-banner/2021-12-21-activey',
    name: 'app-banner-2021-12-21-activey',
    component: (res) => require(['@/views/app-banner/2021-12-21-active'], res),
    meta: {
      title: '减脂食品研究所'
    }
  },
  {
    path: '/app-banner/image-page',
    name: 'app-banner-image-page',
    component: (res) => require(['@/views/app-banner/image-page'], res),
    meta: {
      title: 'banner详情'
    }
  },
  {
    path: '/die-selection',
    name: 'die-selection',
    component: (res) =>
      require(['@/views/activity/die-selection/die-selection'], res),
    meta: {
      title: '明星营养师评选'
    }
  },
  {
    path: '/die-selection-rule',
    name: 'die-selection-rule',
    component: (res) =>
      require(['@/views/activity/die-selection/die-selection-rule'], res),
    meta: {
      title: '明星营养师评选-规则'
    }
  },
  {
    path: '/die-selection-pro',
    name: 'die-selection-pro',
    component: (res) =>
      require(['@/views/activity/die-selection/die-selection-pro'], res),
    meta: {
      title: '明星营养师评选-我的奖励'
    }
  },
  {
    path: '/camp-archives',
    name: 'camp-archives',
    component: (res) =>
      require(['@/views/useBoth/camp-archives/camp-archives'], res),
    meta: {
      title: '营期档案'
    }
  },
  {
    path: '/recipe-list',
    name: 'recipe-list',
    component: (res) => require(['@/views/useBoth/recipe/recipe-list'], res),
    meta: {
      title: '营养评估方案'
    }
  },
  {
    path: '/recipe-question',
    name: 'recipe-question',
    component: (res) =>
      require(['@/views/useBoth/recipe/recipe-question'], res),
    meta: {
      title: '评估问卷'
    }
  },
  {
    path: '/recipe-result',
    name: 'recipe-result',
    component: (res) => require(['@/views/useBoth/recipe/recipe-result'], res),
    meta: {
      title: '营养评估方案'
    }
  },
  {
    path: '/recipe-feedback',
    name: 'recipe-feedback',
    component: (res) =>
      require(['@/views/useBoth/recipe/recipe-feedback'], res),
    meta: {
      title: '使用反馈'
    }
  },
  {
    path: '/recipe-feedbackStatus',
    name: 'recipe-feedbackStatus',
    component: (res) =>
      require(['@/views/useBoth/recipe/recipe-feedbackStatus'], res),
    meta: {
      title: '使用反馈'
    }
  },
  {
    path: '/stage-question',
    name: 'stage-question',
    component: (res) =>
      require(['@/views/useBoth/stage-question/stage-question'], res),
    meta: {
      title: '测试问卷'
    }
  },
  {
    path: '/qualification',
    name: 'qualification',
    component: (res) => require(['@/views/upred/qualification'], res),
    meta: {
      title: '当红不让公司资质'
    }
  },
  {
    path: '/goddess-festival',
    name: 'goddess-festival',
    component: (res) =>
      require(['@/views/activity/goddess-festival/index'], res),
    meta: {
      title: '女神节抽奖'
    }
  },
  {
    path: '/goddess-festival-prize',
    name: 'goddess-festival-prize',
    component: (res) =>
      require(['@/views/activity/goddess-festival/my-prize'], res),
    meta: {
      title: '女神节抽奖'
    }
  },
  {
    path: '/calorie-query/index',
    name: 'calorie-query-index',
    component: (res) => require(['@/views/calorie-query/index'], res),
    meta: {
      title: '食物档案',
      webview: {
        keepAlive: true,
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/calorie-query/search',
    name: 'calorie-query-search',
    component: (res) => require(['@/views/calorie-query/food-search'], res),
    meta: {
      keepAlive: true,
      desc: '搜索食物',
      title: '食物档案',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/calorie-query/food-list',
    name: 'calorie-query-class-list',
    component: (res) => require(['@/views/calorie-query/food-class-list'], res),
    meta: {
      keepAlive: true,
      desc: '食物列表',
      title: '食物档案',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/calorie-query/food-info',
    name: 'calorie-query-food-info',
    component: (res) => require(['@/views/calorie-query/food-info'], res),
    meta: {
      desc: '食物信息',
      title: '食物档案',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/calorie-query/food-details',
    name: 'calorie-query-food-details',
    component: (res) => require(['@/views/calorie-query/food-details'], res),
    meta: {
      desc: '食物详情',
      title: '食物档案'
    }
  },
  {
    path: '/calorie-query/food-rank',
    name: 'calorie-query-food-rank',
    component: (res) => require(['@/views/calorie-query/food-rank'], res),
    meta: {
      desc: '食物排行',
      title: '食物档案'
    }
  },
  {
    path: '/calorie-query/super-food-detail',
    name: 'calorie-query-super-food-detail',
    component: (res) =>
      require(['@/views/calorie-query/super-food-detail'], res),
    meta: {
      desc: '食物档案',
      title: '超级食物',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  /* 星球档案 */
  {
    path: '/planet-record/index',
    name: 'planet-record-index',
    component: (res) => require(['@/views/planet-record/index'], res),
    meta: {
      desc: '星球档案首页',
      title: '我的档案',
      webview: {
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/planet-record/detail',
    name: 'planet-record-detail',
    component: (res) => require(['@/views/planet-record/detail'], res),
    meta: {
      desc: '星球档案详情',
      title: '我的档案',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  /* 减脂营转介绍 */
  {
    path: '/camp-invite/index',
    name: 'camp-invite-index',
    component: (res) =>
      require(['@/views/activity/camp-introduce/old-member'], res),
    meta: {
      desc: '老会员邀请好友界面',
      title: '邀请有礼'
    }
  },
  {
    path: '/camp-invite/inviteSchedule',
    name: 'camp-invite-schedule',
    component: (res) =>
      require(['@/views/activity/camp-introduce/invite-schedule'], res),
    meta: {
      desc: '邀请好友进度',
      title: '邀请有礼'
    }
  },
  {
    path: '/camp-invite/invite',
    name: 'camp-invite-invite',
    component: (res) =>
      require(['@/views/activity/camp-introduce/new-member'], res),
    meta: {
      desc: '新会员领取界面',
      title: '邀请有礼'
    }
  },
  {
    path: '/camp-invite/receive',
    name: 'camp-invite-receive',
    component: (res) =>
      require(['@/views/activity/camp-introduce/receive-status'], res),
    meta: {
      desc: '新会员领取成功界面',
      title: '邀请有礼'
    }
  },
  {
    path: '/camp-invite/rules',
    name: 'camp-invite-rules',
    component: (res) =>
      require(['@/views/activity/camp-introduce/invite-rules'], res),
    meta: {
      desc: '新老会员邀请好友规则',
      title: '邀请有礼'
    }
  },
  //学员案例
  {
    path: '/case-detail',
    name: 'case-detail',
    component: (res) =>
      require(['@/views/useApp/case-library/case-detail'], res),
    meta: {
      desc: '学员案例详情',
      title: '详情',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  //配料表
  {
    path: '/ingredient/index',
    name: 'ingredient-index',
    component: (res) => require(['@/views/useBoth/ingredient-list/index'], res),
    meta: {
      desc: '拍照解析配料表',
      title: '解析配料表',
      webview: {
        title: '',
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1
      }
    }
  },
  {
    path: '/ingredient/preview',
    name: 'ingredient-preview',
    component: (res) =>
      require(['@/views/useBoth/ingredient-list/preview-image'], res),
    meta: {
      desc: '配料图片预览',
      title: '图片预览'
    }
  },
  {
    path: '/ingredient/result',
    name: 'ingredient-result',
    component: (res) =>
      require(['@/views/useBoth/ingredient-list/result'], res),
    meta: {
      desc: '配料解析结果',
      title: '配料解析结果',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/ingredient/error',
    name: 'ingredient-error',
    component: (res) => require(['@/views/useBoth/ingredient-list/error'], res),
    meta: {
      desc: '配料解析失败',
      title: '配料解析结果'
    }
  },
  {
    path: '/lisa-questionnaire',
    name: 'lisa-questionnaire',
    component: (res) =>
      require(['@/views/useApp/lisa-questionnaire/lisa-questionnaire'], res),
    meta: {
      title: '四大体型测评'
    }
  },
  /* 添加营养师 */
  {
    path: '/useMini/add-dietitian',
    name: 'useMini-add-dietitian',
    component: (res) => require(['@/views/useMini/add-dietitian'], res),
    meta: {
      desc: '配料解析失败',
      title: '添加营养师'
    }
  },
  /* 营养干预方案结果页 */
  {
    path: '/questionnaire/result',
    name: 'questionnaire-result',
    component: (res) =>
      require(['@/views/useApp/questionnaire/questionnaire-result'], res),
    meta: {
      desc: '营养干预方案',
      title: '营养干预方案'
    }
  },
  /* 喝水提醒 */
  {
    path: '/drink-water-reminder/index',
    name: 'drink-water-reminder-index',
    component: (res) =>
      require(['@/views/useApp/drink-water-reminder/index'], res),
    meta: {
      desc: '喝水提醒',
      title: '喝水提醒',
      keepAlive: true,
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/drink-water-reminder/normal/index',
    name: 'drink-water-reminder-normal-index',
    component: (res) =>
      require(['@/views/useApp/drink-water-reminder/normal/index'], res),
    meta: {
      keepAlive: true,
      desc: '喝水提醒',
      title: '喝水提醒',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/drink-water-reminder/fill',
    name: 'drink-water-reminder-fill',
    component: (res) =>
      require(['@/views/useApp/drink-water-reminder/fill-info'], res),
    meta: {
      desc: '喝水提醒方案定制',
      title: '',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/drink-water-reminder/start',
    name: 'drink-water-reminder-start',
    component: (res) =>
      require(['@/views/useApp/drink-water-reminder/start'], res),
    meta: {
      desc: '喝水提醒启动页',
      title: '喝水提醒',
      webview: {
        title: '',
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1
      }
    }
  },
  {
    path: '/drink-water-reminder/normal/set',
    name: 'drink-water-reminder-normal-set',
    component: (res) =>
      require(['@/views/useApp/drink-water-reminder/normal/set'], res),
    meta: {
      keepAlive: true,
      desc: '喝水提醒设置',
      title: '提醒设置',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/drink-water-reminder/set',
    name: 'drink-water-reminder-set',
    component: (res) =>
      require(['@/views/useApp/drink-water-reminder/set'], res),
    meta: {
      keepAlive: true,
      desc: '喝水提醒设置',
      title: '提醒设置',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/drink-water-reminder/generate',
    name: 'drink-water-reminder-generate',
    component: (res) =>
      require(['@/views/useApp/drink-water-reminder/generate'], res),
    meta: {
      desc: '喝水提醒设置',
      title: '提醒设置',
      webview: {
        title: '',
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1
      }
    }
  },
  {
    path: '/drink-water-reminder/help',
    name: 'drink-water-reminder-help',
    component: (res) =>
      require(['@/views/useApp/drink-water-reminder/help'], res),
    meta: {
      desc: '扫码失败提示',
      title: '帮助'
    }
  },
  {
    path: '/drink-water-reminder/register',
    name: 'drink-water-reminder-register',
    component: (res) =>
      require(['@/views/useApp/drink-water-reminder/register'], res),
    meta: {
      desc: '彩虹杯注册',
      title: '彩虹杯'
    }
  },
  {
    path: '/drink-water-reminder/register-success',
    name: 'drink-water-reminder-register-success',
    component: (res) =>
      require(['@/views/useApp/drink-water-reminder/register-success'], res),
    meta: {
      desc: '彩虹杯注册成功',
      title: '彩虹杯'
    }
  },
  /* 积分中心 */
  {
    path: '/points-center/index',
    name: 'points-center-index',
    component: (res) => require(['@/views/useApp/points-center/index'], res),
    meta: {
      desc: '积分中心首页',
      title: '积分中心',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/books-receive/index',
    name: 'books-receive-index',
    component: (res) => require(['@/views/useApp/books-receive/index'], res),
    meta: {
      desc: '湘雅体重管理课',
      title: '湘雅体重管理课'
    }
  },
  /* 营养师点评工具 */
  {
    path: '/nutritionist-tool/camp-list',
    name: 'nutritionist-tool-camp-list',
    component: (res) =>
      require(['@/views/useApp/nutritionist-reviews-tool/camp-list'], res),
    meta: {
      keepAlive: true,
      desc: '营养师工具',
      title: '营养师工具'
    }
  },
  {
    path: '/nutritionist-tool/diet-list',
    name: 'nutritionist-tool-diet-list',
    component: (res) =>
      require(['@/views/useApp/nutritionist-reviews-tool/diet-list'], res),
    meta: {
      keepAlive: true,
      desc: '营养师工具',
      title: '营养师工具'
    }
  },
  {
    path: '/nutritionist-tool/review-detail',
    name: 'nutritionist-tool-review-detail',
    component: (res) =>
      require(['@/views/useApp/nutritionist-reviews-tool/review-detail'], res),
    meta: {
      desc: '营养师工具',
      title: '餐卡点评'
    }
  },
  {
    path: '/recipe-cna-start',
    name: 'recipe-cna-start',
    component: (res) =>
      require(['@/views/useBoth/recipe-cna/recipe-cna-start'], res),
    meta: {
      desc: '营养评估-4.0',
      title: 'CNA 全方位营养评估'
    }
  },
  {
    path: '/recipe-cna-notice',
    name: 'recipe-cna-notice',
    component: (res) =>
      require(['@/views/useBoth/recipe-cna/recipe-cna-notice'], res),
    meta: {
      desc: '营养评估-4.0',
      title: '告知书'
    }
  },
  {
    path: '/recipe-cna-ques',
    name: 'recipe-cna-ques',
    component: (res) =>
      require(['@/views/useBoth/recipe-cna/recipe-cna-ques'], res),
    meta: {
      desc: '营养评估-4.0',
      title: 'CNA 全方位营养评估'
    }
  },
  {
    path: '/recipe-cna-submit',
    name: 'recipe-cna-submit',
    component: (res) =>
      require(['@/views/useBoth/recipe-cna/recipe-cna-submit'], res),
    meta: {
      desc: '营养评估-4.0',
      title: '提交结果'
    }
  },
  {
    path: '/recipe-cna-result',
    name: 'recipe-cna-result',
    component: (res) =>
      require(['@/views/useBoth/recipe-cna/recipe-cna-result'], res),
    meta: {
      desc: '营养评估-4.0',
      title: 'CNA 全方位营养评估'
    }
  },
  {
    path: '/recipe-cna-register',
    name: 'recipe-cna-register',
    component: (res) =>
      require(['@/views/useBoth/recipe-cna/recipe-cna-register'], res),
    meta: {
      desc: '营养评估-4.0',
      title: 'CNA 全方位营养评估注册'
    }
  },
  {
    path: '/recipe-cna-active',
    name: 'recipe-cna-active',
    component: (res) =>
      require(['@/views/useBoth/recipe-cna/recipe-cna-active'], res),
    meta: {
      desc: '营养评估-4.0',
      title: 'CNA 全方位营养评估激活'
    }
  },
  {
    path: '/recipe-cna-download',
    name: 'recipe-cna-download',
    component: (res) =>
      require(['@/views/useBoth/recipe-cna/recipe-cna-download'], res),
    meta: {
      desc: '营养评估-4.0',
      title: 'CNA 全方位营养评估App下载'
    }
  },
  /*  */
  {
    path: '/user-data',
    name: 'user-data',
    component: (res) => require(['@/views/useBoth/user-data/index'], res),
    meta: {
      desc: '',
      title: '我的数据'
    }
  },
  {
    path: '/user-mark',
    name: 'user-mark',
    component: (res) => require(['@/views/useBoth/user-data/user-mark'], res),
    meta: {
      desc: '',
      title: '修改备注'
    }
  },
  {
    path: '/user-tag',
    name: 'user-tag',
    component: (res) => require(['@/views/useBoth/user-data/user-tag'], res),
    meta: {
      desc: '',
      title: '设置标签'
    }
  },
  {
    path: '/nutritionist-tool/review-old-detail',
    name: 'nutritionist-tool-review-old-detail',
    component: (res) =>
      require([
        '@/views/useApp/nutritionist-reviews-tool/review-old-detail/index'
      ], res),
    meta: {
      desc: '营养师工具',
      title: '营养师工具'
    }
  },
  {
    path: '/nutritionist-tool/today-review',
    name: 'nutritionist-tool-today-review',
    component: (res) =>
      require([
        '@/views/useApp/nutritionist-reviews-tool/today-review/index'
      ], res),
    meta: {
      desc: '营养师工具',
      title: '今日餐卡点评'
    }
  },
  {
    path: '/nutritionist-tool/diet-calendar',
    name: 'nutritionist-tool-diet-calendar',
    component: (res) =>
      require(['@/views/useApp/nutritionist-reviews-tool/diet-calendar'], res),
    meta: {
      desc: '营养师工具',
      title: '打卡日历'
    }
  },
  /* 减脂营转介绍v2版本 */
  {
    path: '/camp-invite-v2/index',
    name: 'camp-invite-v2-index',
    component: (res) =>
      require(['@/views/activity/camp-introduce-v2/old-member'], res),
    meta: {
      desc: '老会员邀请好友界面',
      title: '分享有礼',
      webview: {
        title: '分享有礼',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/camp-invite-v2/inviteSchedule',
    name: 'camp-invite-v2-schedule',
    component: (res) =>
      require(['@/views/activity/camp-introduce-v2/invite-schedule'], res),
    meta: {
      desc: '邀请好友进度',
      title: '分享有礼',
      webview: {
        title: '分享有礼',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/civ2/i',
    name: 'camp-invite-v2-invite',
    component: (res) =>
      require(['@/views/activity/camp-introduce-v2/new-member'], res),
    meta: {
      desc: '新会员领取界面',
      title: '分享有礼',
      webview: {
        title: '分享有礼',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/camp-invite-v2/receive',
    name: 'camp-invite-v2-receive',
    component: (res) =>
      require(['@/views/activity/camp-introduce-v2/receive-status'], res),
    meta: {
      desc: '新会员领取成功界面',
      title: '分享有礼',
      webview: {
        title: '分享有礼',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/camp-invite-v2/rules',
    name: 'camp-invite-v2-rules',
    component: (res) =>
      require(['@/views/activity/camp-introduce-v2/invite-rules'], res),
    meta: {
      desc: '新老会员邀请好友规则',
      title: '分享有礼',
      webview: {
        title: '分享有礼',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        isShowToolsBar: false
      }
    }
  },
  /* 减脂营转介绍v2版本 */
  {
    path: '/camp-invite-v3/index',
    name: 'camp-invite-v3-index',
    component: (res) =>
      require(['@/views/activity/camp-introduce-v3/old-member'], res),
    meta: {
      desc: '老会员邀请好友界面',
      title: '传播有礼',
      webview: {
        title: '传播有礼',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/camp-invite-v3/inviteSchedule',
    name: 'camp-invite-v3-schedule',
    component: (res) =>
      require(['@/views/activity/camp-introduce-v3/invite-schedule'], res),
    meta: {
      desc: '邀请好友进度',
      title: '传播记录',
      webview: {
        title: '传播记录',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/civ3/i',
    name: 'camp-invite-v3-invite',
    component: (res) =>
      require(['@/views/activity/camp-introduce-v3/new-member'], res),
    meta: {
      desc: '新会员领取界面',
      title: '传播有礼',
      webview: {
        title: '传播有礼',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/camp-invite-v3/receive',
    name: 'camp-invite-v3-receive',
    component: (res) =>
      require(['@/views/activity/camp-introduce-v3/receive-status'], res),
    meta: {
      desc: '新会员领取成功界面',
      title: '传播有礼',
      webview: {
        title: '传播有礼',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/camp-invite-v3/rules',
    name: 'camp-invite-v3-rules',
    component: (res) =>
      require(['@/views/activity/camp-introduce-v3/invite-rules'], res),
    meta: {
      desc: '新老会员邀请好友规则',
      title: '活动规则',
      webview: {
        title: '活动规则',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        isShowToolsBar: false
      }
    }
  },
  /* 分享有礼通用版 */
  {
    path: '/camp-invite-common/index',
    name: 'camp-invite-common-index',
    component: (res) =>
      require(['@/views/activity/camp-introduce-common/old-member'], res),
    meta: {
      desc: '老会员邀请好友界面',
      title: '传播有礼',
      webview: {
        title: '传播有礼',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/camp-invite-common/inviteSchedule',
    name: 'camp-invite-common-schedule',
    component: (res) =>
      require(['@/views/activity/camp-introduce-common/invite-schedule'], res),
    meta: {
      desc: '邀请好友进度',
      title: '传播记录',
      webview: {
        title: '传播记录',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/cic/i',
    name: 'camp-invite-common-invite',
    component: (res) =>
      require(['@/views/activity/camp-introduce-common/new-member'], res),
    meta: {
      desc: '新会员领取界面',
      title: '传播有礼',
      webview: {
        title: '传播有礼',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/camp-invite-common/receive',
    name: 'camp-invite-common-receive',
    component: (res) =>
      require(['@/views/activity/camp-introduce-common/receive-status'], res),
    meta: {
      desc: '新会员领取成功界面',
      title: '传播有礼',
      webview: {
        title: '传播有礼',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/camp-invite-common/rules',
    name: 'camp-invite-common-rules',
    component: (res) =>
      require(['@/views/activity/camp-introduce-common/invite-rules'], res),
    meta: {
      desc: '新老会员邀请好友规则',
      title: '活动规则',
      webview: {
        title: '活动规则',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/camp-invite-common/fill',
    name: 'camp-invite-common-fill',
    component: (res) =>
      require(['@/views/activity/camp-introduce-common/fill-invite-code'], res),
    meta: {
      desc: '邀请码填写',
      title: '邀请码填写',
      webview: {
        title: '邀请码填写',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        isShowToolsBar: false
      }
    }
  },
  /* 新人专区问卷 */
  {
    path: '/newcomer-questionnaire/result',
    name: 'newcomer-questionnaire-result',
    component: (res) =>
      require(['@/views/useApp/newcomer-questionnaire/result'], res),
    meta: {
      desc: '新人专区问卷结果页',
      title: '我的一站式减脂方案',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/newcomer-questionnaire/index',
    name: 'newcomer-questionnaire-index',
    component: (res) =>
      require(['@/views/useApp/newcomer-questionnaire/question'], res),
    meta: {
      desc: '新人专区问卷结果页',
      title: '我的一站式减脂方案',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  /* 今天吃什么 */
  {
    path: '/eating-today/home',
    name: 'eating-today-index',
    component: (res) => require(['@/views/useApp/eating-today/generate'], res),
    meta: {
      desc: '今天吃什么',
      title: '今天吃什么',
      webview: {
        title: '',
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1
      }
    }
  },
  {
    path: '/eating-today/index',
    name: 'eating-today-home',
    component: (res) => require(['@/views/useApp/eating-today-v2/index'], res),
    meta: {
      keepAlive: true,
      desc: '今天吃什么首页',
      title: '今天吃什么',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/eating-today/instructions',
    name: 'eating-today-instructions',
    component: (res) =>
      require(['@/views/useApp/eating-today/instructions'], res),
    meta: {
      desc: '今天吃什么饭盒使用说明',
      title: '饭盒使用说明',
      webview: {}
    }
  },
  {
    path: '/eating-today/fill-info',
    name: 'eating-today-fill-info',
    component: (res) => require(['@/views/useApp/eating-today/fill-info'], res),
    meta: {
      desc: '今天吃什么信息填写',
      title: '今天吃什么',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  /*  */
  {
    path: '/eating-today/start',
    name: 'eating-today-start',
    component: (res) => require(['@/views/useApp/eating-today/start'], res),
    meta: {
      desc: '今天吃什么启动页',
      title: '今天吃什么',
      webview: {
        title: '',
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1
      }
    }
  },
  {
    path: '/eating-today/help',
    name: 'eating-today-help',
    component: (res) => require(['@/views/useApp/eating-today/help'], res),
    meta: {
      desc: '扫码失败提示',
      title: '帮助'
    }
  },
  {
    path: '/eating-today/register',
    name: 'eating-today-register',
    component: (res) => require(['@/views/useApp/eating-today/register'], res),
    meta: {
      desc: '今天吃什么注册',
      title: '今天吃什么'
    }
  },
  {
    path: '/eating-today/register-success',
    name: 'eating-today-register-success',
    component: (res) =>
      require(['@/views/useApp/eating-today/register-success'], res),
    meta: {
      desc: '今天吃什么注册成功',
      title: '今天吃什么'
    }
  },
  {
    path: '/week-summary',
    name: 'week-summary',
    component: (res) =>
      require(['@/views/useBoth/week-summary/week-summary'], res),
    meta: {
      desc: '',
      title: '周总结',
      webview: {}
    }
  },
  {
    path: '/week-summary-list',
    name: 'week-summary-list',
    component: (res) =>
      require(['@/views/useBoth/week-summary/week-summary-list'], res),
    meta: {
      desc: '',
      title: '周总结',
      webview: {}
    }
  },
  {
    path: '/summary-list',
    name: 'summary-list',
    component: (res) =>
      require(['@/views/useBoth/week-summary/summary-list'], res),
    meta: {
      desc: '',
      title: '总结',
      webview: {}
    }
  },
  {
    path: '/mtxx-h5',
    name: 'mtxx-h5',
    component: (res) => require(['@/views/activity/mtxx-h5/mtxx-h5'], res),
    meta: {
      desc: '',
      title: '美图秀秀福利中心',
      webview: {}
    }
  },
  {
    path: '/dy-wx-h5',
    name: 'dy-wx-h5',
    component: (res) => require(['@/views/activity/dy-wx-h5/dy-wx-h5'], res),
    meta: {
      desc: '',
      title: '精品营养课',
      webview: {}
    }
  },
  /* 饮食计算器 */
  {
    path: '/diet-calculator/index',
    name: 'diet-calculator-index',
    component: (res) => require(['@/views/useApp/diet-calculator/index'], res),
    meta: {
      desc: '',
      title: '',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff'
      }
    }
  },
  {
    path: '/diet-calculator/question',
    name: 'diet-calculator-question',
    component: (res) =>
      require(['@/views/useApp/diet-calculator/question'], res),
    meta: {
      desc: '',
      title: '饮食计算器',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/diet-calculator/result',
    name: 'diet-calculator-result',
    component: (res) => require(['@/views/useApp/diet-calculator/result'], res),
    meta: {
      desc: '',
      title: '饮食计算结果',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/diet-calculator/analyze',
    name: 'diet-calculator-analyze',
    component: (res) =>
      require(['@/views/useApp/diet-calculator/analyze'], res),
    meta: {
      desc: '',
      title: '',
      webview: {}
    }
  },
  {
    path: '/diet-calculator/collect',
    name: 'diet-calculator-collect',
    component: (res) =>
      require(['@/views/useApp/diet-calculator/collect'], res),
    meta: {
      desc: '',
      title: '我收藏的方案',
      webview: {}
    }
  },
  /* 微信直接打开营养师聊天 */
  {
    path: '/consult/wx',
    name: 'consult-wx',
    component: (res) => require(['@/views/useApp/consult-us/index'], res),
    meta: {
      desc: '',
      title: '联系营养师',
      webview: {}
    }
  },
  /* betterwe大会员界面 */
  {
    path: '/betterwe/vip',
    name: 'betterwe-vip',
    component: (res) => require(['@/views/useApp/betterwe-vip/vip'], res),
    meta: {
      keepAlive: true,
      desc: '',
      title: 'WE+减脂会员',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  /* 会员权益详情 */
  {
    path: '/betterwe/vip-detail',
    name: 'betterwe-vip-detail',
    component: (res) =>
      require(['@/views/useApp/betterwe-vip/vip-detail'], res),
    meta: {
      desc: '',
      title: 'WE+减脂会员',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/betterwe/vip-agreement',
    name: 'betterwe-vip-agreement',
    component: (res) => require(['@/views/useApp/betterwe-vip/agreement'], res),
    meta: {
      desc: '',
      title: '会员服务协议',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/betterwe/vip-explain',
    name: 'betterwe-vip-explain',
    component: (res) =>
      require(['@/views/useApp/betterwe-vip/vip-explain'], res),
    meta: {
      desc: '',
      title: '权益说明',
      webview: {
        title: '权益说明'
      }
    }
  },
  {
    path: '/betterwe/reserve',
    name: 'betterwe-reserve',
    component: (res) =>
      require(['@/views/useApp/betterwe-vip/camp-reserve'], res),
    meta: {
      desc: '',
      title: '预约餐卡点评',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/dy-to-wx',
    name: 'dy-to-wx',
    component: (res) => require(['@/views/activity/dy-wx-h5/dy-to-wx'], res),
    meta: {
      desc: '',
      title: '21天蜕变计划',
      webview: {}
    }
  },
  {
    path: '/dy-to-wx-v2',
    name: 'dy-to-wx-v2',
    component: (res) => require(['@/views/activity/dy-wx-h5/dy-to-wx-v2'], res),
    meta: {
      desc: '',
      title: '21天蜕变计划',
      webview: {}
    }
  },
  {
    path: '/dy-add-customer',
    name: 'dy-add-customer',
    component: (res) =>
      require(['@/views/activity/dy-wx-h5/dy-add-customer'], res),
    meta: {
      desc: '',
      title: '21天蜕变计划',
      webview: {}
    }
  },
  {
    path: '/dy-to-wx-shop',
    name: 'dy-to-wx-shop',
    component: (res) =>
      require(['@/views/activity/dy-wx-h5/dy-to-wx-shop'], res),
    meta: {
      desc: '',
      title: '7步挑战吃出好身材',
      webview: {}
    }
  },
  {
    path: '/dy-add-customer-shop',
    name: 'dy-add-customer-shop',
    component: (res) =>
      require(['@/views/activity/dy-wx-h5/dy-add-customer-shop'], res),
    meta: {
      desc: '',
      title: '7步挑战吃出好身材',
      webview: {}
    }
  },
  {
    path: '/lowcode-active',
    name: 'lowcode-active',
    component: (res) => require(['@/views/lowcode-active'], res)
  },
  /* 问卷系统 */
  {
    path: '/common-questions/home',
    name: 'common-questions-home',
    component: (res) => require(['@/views/useBoth/common-questions/home'], res),
    meta: {
      keepAlive: true,
      desc: '全部问卷',
      title: '全部问卷',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/common-questions/my-question',
    name: 'common-questions-my-question',
    component: (res) =>
      require(['@/views/useBoth/common-questions/my-question'], res),
    meta: {
      desc: '已填问卷',
      title: '已填问卷',
      webview: {
        isTransparentBottomBar: 1
      }
    }
  },
  {
    path: '/common-questions',
    name: 'common-questions',
    component: (res) =>
      require(['@/views/useBoth/common-questions/index'], res),
    meta: {
      desc: '',
      title: '问卷',
      webview: {
        isTransparentBottomBar: 1
        /* toolsBarBgColor: '#00000000',
                statusColor: '#00000000',
                isTransparentBottomBar: 1,
                titleColor: '#ffffff',
                isShowToolsBar: false */
      }
    }
  },
  {
    path: '/common-questions/start',
    name: 'common-questions-start',
    component: (res) =>
      require(['@/views/useBoth/common-questions/start'], res),
    meta: {
      desc: '问卷海报',
      title: 'betterWE星球',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/common-questions/q1-result',
    name: 'common-questions-q1-result',
    component: (res) =>
      require(['@/views/useBoth/common-questions/questions/q-1/result'], res),
    meta: {
      desc: '',
      title: '',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/common-questions/q2-result',
    name: 'common-questions-q2-result',
    component: (res) =>
      require(['@/views/useBoth/common-questions/questions/q-2/result'], res),
    meta: {
      desc: '',
      title: '',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/common-questions/q3-result',
    name: 'common-questions-q3-result',
    component: (res) =>
      require(['@/views/useBoth/common-questions/questions/q-3/result'], res),
    meta: {
      desc: '',
      title: '',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/common-questions/q4-result',
    name: 'common-questions-q4-result',
    component: (res) =>
      require(['@/views/useBoth/common-questions/questions/q-4/result'], res),
    meta: {
      desc: '',
      title: '',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/common-questions/q5-result',
    name: 'common-questions-q5-result',
    component: (res) =>
      require(['@/views/useBoth/common-questions/questions/q-5/result'], res),
    meta: {
      desc: '',
      title: '',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/common-questions/q6-result',
    name: 'common-questions-q6-result',
    component: (res) =>
      require(['@/views/useBoth/common-questions/questions/q-6/result'], res),
    meta: {
      desc: '',
      title: '',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/common-questions/q7-result',
    name: 'common-questions-q7-result',
    component: (res) =>
      require(['@/views/useBoth/common-questions/questions/q-7/result'], res),
    meta: {
      desc: '',
      title: '',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  /*  */
  {
    path: '/common-questions/result',
    name: 'common-questions-result',
    component: (res) =>
      require(['@/views/useBoth/common-questions/result'], res),
    children: [
      {
        path: 'q1',
        component: (res) =>
          require([
            '@/views/useBoth/common-questions/questions/q-1/result'
          ], res),
        meta: {
          desc: '',
          title: '测评结果',
          webview: {
            toolsBarBgColor: '#00000000',
            statusColor: '#00000000',
            isTransparentBottomBar: 1,
            titleColor: '#ffffff',
            isShowToolsBar: false
          }
        }
      },
      {
        path: 'q2',
        component: (res) =>
          require([
            '@/views/useBoth/common-questions/questions/q-2/result'
          ], res),
        meta: {
          desc: '',
          title: '测评结果',
          webview: {
            toolsBarBgColor: '#00000000',
            statusColor: '#00000000',
            isTransparentBottomBar: 1,
            titleColor: '#ffffff',
            isShowToolsBar: false
          }
        }
      },
      {
        path: 'q3',
        component: (res) =>
          require([
            '@/views/useBoth/common-questions/questions/q-3/result'
          ], res),
        meta: {
          desc: '',
          title: '测评结果',
          webview: {
            toolsBarBgColor: '#00000000',
            statusColor: '#00000000',
            isTransparentBottomBar: 1,
            titleColor: '#ffffff',
            isShowToolsBar: false
          }
        }
      },
      {
        path: 'q4',
        component: (res) =>
          require([
            '@/views/useBoth/common-questions/questions/q-4/result'
          ], res),
        meta: {
          desc: '',
          title: '回访结果',
          webview: {
            toolsBarBgColor: '#00000000',
            statusColor: '#00000000',
            isTransparentBottomBar: 1,
            titleColor: '#ffffff',
            isShowToolsBar: false
          }
        }
      },
      {
        path: 'q5',
        component: (res) =>
          require([
            '@/views/useBoth/common-questions/questions/q-5/result'
          ], res),
        meta: {
          desc: '',
          title: '问卷结果',
          webview: {
            toolsBarBgColor: '#00000000',
            statusColor: '#00000000',
            isTransparentBottomBar: 1,
            titleColor: '#ffffff',
            isShowToolsBar: false
          }
        }
      },
      {
        path: 'q6',
        component: (res) =>
          require([
            '@/views/useBoth/common-questions/questions/q-6/result'
          ], res),
        meta: {
          desc: '',
          title: '测评结果',
          webview: {
            toolsBarBgColor: '#00000000',
            statusColor: '#00000000',
            isTransparentBottomBar: 1,
            titleColor: '#ffffff',
            isShowToolsBar: false
          }
        }
      },
      {
        path: 'q7',
        component: (res) =>
          require([
            '@/views/useBoth/common-questions/questions/q-7/result'
          ], res),
        meta: {
          desc: '',
          title: '测评结果',
          webview: {
            toolsBarBgColor: '#00000000',
            statusColor: '#00000000',
            isTransparentBottomBar: 1,
            titleColor: '#ffffff',
            isShowToolsBar: false
          }
        }
      },
      {
        path: 'q11',
        component: (res) =>
          require([
            '@/views/useBoth/common-questions/questions/q-11/result'
          ], res),
        meta: {
          desc: '',
          title: '提交成功',
          webview: {
            toolsBarBgColor: '#00000000',
            statusColor: '#00000000',
            isTransparentBottomBar: 1,
            titleColor: '#ffffff',
            isShowToolsBar: false
          }
        }
      },
      {
        path: 'q12',
        component: (res) =>
          require([
            '@/views/useBoth/common-questions/questions/q-12/result'
          ], res),
        meta: {
          desc: '',
          title: '提交成功',
          webview: {
            toolsBarBgColor: '#00000000',
            statusColor: '#00000000',
            isTransparentBottomBar: 1,
            titleColor: '#ffffff',
            isShowToolsBar: false
          }
        }
      },
      /* 都未找到时 */
      {
        path: '*',
        component: (res) =>
          require([
            '@/views/useBoth/common-questions/questions/err/index'
          ], res),
        meta: {
          desc: '',
          title: '',
          webview: {
            toolsBarBgColor: '#00000000',
            statusColor: '#00000000',
            isTransparentBottomBar: 1,
            titleColor: '#ffffff',
            isShowToolsBar: false
          }
        }
      }
    ],

    meta: {
      desc: '',
      title: '',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/douyin/live/copy-pwd',
    name: 'douyin-live-copy-pwd',
    component: (res) => require(['@/views/useApp/douyin/live'], res),
    meta: {
      desc: '',
      title: '抖音直播',
      webview: {}
    }
  },
  {
    path: '/coach-prove-2023',
    name: 'coach-prove-2023',
    component: (res) =>
      require(['@/views/appointment/ponents/coach-prove-2023'], res),
    meta: {
      desc: '',
      title: '',
      webview: {}
    }
  },
  {
    path: '/nutrition-hotspots',
    name: 'nutrition-hotspots',
    component: (res) =>
      require(['@/views/useApp/nutrition-hotspots/index'], res),
    meta: {
      desc: '',
      title: '',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/dynamic-detail',
    name: 'dynamic-detail',
    component: (res) => require(['@/views/useApp/dynamic-detail'], res),
    meta: {
      desc: '',
      title: '动态详情',
      webview: {}
    }
  },
  {
    path: '/demo',
    name: 'demo',
    component: (res) => require(['@/views/demo/demo'], res),
    meta: {
      desc: '',
      title: '测试链接',
      webview: {}
    }
  },
  {
    path: '/wm_login_callback',
    name: 'wm_login_callback',
    component: (res) => require(['@/views/weimeng/index'], res),
    meta: {
      desc: '',
      title: '微盟登录'
    }
  },
  {
    path: '/privacy-agreement',
    name: 'privacy-agreement',
    component: (res) =>
      require(['@/views/useApp/privacy-agreement/index'], res),
    meta: {
      desc: '',
      title: '隐私政策',
      webview: {}
    }
  },
  /* 文章详情 */
  {
    path: '/article-detail',
    name: 'article-detail',
    component: (res) => require(['@/views/useApp/article-detail/index'], res),
    meta: {
      desc: '',
      title: '文章详情',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/contact-us',
    name: 'contact-us',
    component: (res) => require(['@/views/useApp/contact-us/index'], res),
    meta: {
      desc: '',
      title: '内容合作',
      webview: {}
    }
  },
  {
    path: '/contact-menu',
    name: 'contact-menu',
    component: (res) =>
      require(['@/views/useApp/contact-us/contact-menu'], res),
    meta: {
      desc: '',
      title: '联系我们',
      webview: {}
    }
  },
  /* cna问卷 */
  {
    path: '/cna-question-v2/start',
    name: 'cna-question-v2-start',
    component: (res) => require(['@/views/useApp/cna-question-v2/start'], res),
    meta: {
      desc: '',
      title: '',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/cna-question-v2/result',
    name: 'cna-question-v2-result',
    component: (res) => require(['@/views/useApp/cna-question-v2/result'], res),
    meta: {
      keepAlive: true,
      desc: '',
      title: '',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/cna-question-v2/loading',
    name: 'cna-question-v2-loading',
    component: (res) =>
      require(['@/views/useApp/cna-question-v2/loading'], res),
    meta: {
      desc: '',
      title: '',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/cna-question-v2/question',
    name: 'cna-question-v2-question',
    component: (res) => require(['@/views/useApp/cna-question-v2/index'], res),
    meta: {
      desc: '',
      title: '',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/cna-question-v2/create',
    name: 'cna-question-v2-create',
    component: (res) => require(['@/views/useApp/cna-question-v2/create'], res),
    meta: {
      desc: '',
      title: '生成问卷',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/cna-question-v2/recipe',
    name: 'cna-question-v2-recipe',
    component: (res) => require(['@/views/useApp/cna-question-v2/recipe'], res),
    meta: {
      keepAlive: true,
      desc: '',
      title: '',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/cna-question-v2/diet-advice',
    name: 'cna-question-v2-diet-advice',
    component: (res) =>
      require(['@/views/useApp/cna-question-v2/diet-advice'], res),
    meta: {
      desc: '',
      title: '',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/cna-question-v2/daily-goal',
    name: 'cna-question-v2-daily-goal',
    component: (res) =>
      require(['@/views/useApp/cna-question-v2/daily-goal'], res),
    meta: {
      desc: '',
      title: '',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/cna-question-v2/disclaimers',
    name: 'cna-question-v2/disclaimers',
    component: (res) =>
      require(['@/views/useApp/cna-question-v2/disclaimers'], res),
    meta: {
      desc: '',
      title: '',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/endCampCer',
    name: 'endCampCer',
    component: (res) => require(['@/views/useApp/endCampCer/index'], res),
    meta: {
      desc: '',
      title: '结营证书',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/operate-data-report',
    name: 'operate-data-report',
    component: (res) =>
      require(['@/views/useBoth/operate-data-report/index'], res),
    meta: {
      desc: '',
      title: '运营数据看板',
      webview: {}
    }
  },
  {
    path: '/integral-exchange/index',
    name: 'dounyin-integral-exchange-index',
    component: (res) =>
      require(['@/views/dounyin-integral-exchange/index.vue'], res),
    meta: {
      keepAlive: true,
      desc: '',
      title: '鹿鹿会员中心',
      webview: {}
    }
  },
  {
    path: '/integral-exchange/receive',
    name: 'dounyin-integral-exchange-receive',
    component: (res) =>
      require(['@/views/dounyin-integral-exchange/receive.vue'], res),
    meta: {
      desc: '',
      title: '鹿鹿会员中心',
      webview: {}
    }
  },
  {
    path: '/integral-exchange/login',
    name: 'dounyin-integral-exchange-login',
    component: (res) =>
      require(['@/views/dounyin-integral-exchange/login.vue'], res),
    meta: {
      keepAlive: true,
      desc: '',
      title: '',
      webview: {}
    }
  },
  {
    path: '/integral-exchange/exchange',
    name: 'dounyin-integral-exchange-exchange',
    component: (res) =>
      require(['@/views/dounyin-integral-exchange/exchange.vue'], res),
    meta: {
      keepAlive: true,
      desc: '',
      title: '抖音订单转换',
      webview: {}
    }
  },
  {
    path: '/integral-exchange/record',
    name: 'dounyin-integral-exchange-record',
    component: (res) =>
      require(['@/views/dounyin-integral-exchange/record.vue'], res),
    meta: {
      keepAlive: true,
      desc: '',
      title: '抖音订单转换',
      webview: {}
    }
  },
  {
    path: '/integral-exchange/guide',
    name: 'dounyin-integral-exchange-guide',
    component: (res) =>
      require(['@/views/dounyin-integral-exchange/guide.vue'], res),
    meta: {
      desc: '',
      title: '干货指南',
      webview: {}
    }
  },
  /* 新人专区问卷 v2*/
  {
    path: '/newcomer-questionnaire-v2/question',
    name: 'newcomer-questionnaire-v2-question',
    component: (res) =>
      require(['@/views/useApp/newcomer-questionnaire-v2/question'], res),
    meta: {
      desc: '新人专区问卷结果页',
      title: '我的体质评估报告',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/newcomer-questionnaire-v2/index',
    name: 'newcomer-questionnaire-v2-index',
    component: (res) =>
      require(['@/views/useApp/newcomer-questionnaire-v2/index'], res),
    meta: {
      desc: '新人专区问卷结果页',
      title: '我的体质评估报告',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/newcomer-questionnaire-v2/result',
    name: 'newcomer-questionnaire-v2-result',
    component: (res) =>
      require(['@/views/useApp/newcomer-questionnaire-v2/result'], res),
    meta: {
      desc: '新人专区问卷结果页',
      title: '我的体质评估报告',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/draw-fortune',
    name: 'draw-fortune',
    component: (res) => require(['@/views/useApp/draw-fortune/index'], res),
    meta: {
      desc: '',
      title: '抽签',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/lowcode-activity',
    name: 'lowcode-activity',
    component: (res) => require(['@/views/lowcode-activity/index'], res),
    meta: {
      desc: '',
      title: '',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/app-course/audio-course',
    name: 'app-course-audio-course',
    component: (res) =>
      require(['@/views/useApp/app-course/audio-course'], res),
    meta: {
      desc: '音频课程',
      title: '音频课程',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/app-course/course-package',
    name: 'app-course-course-package',
    component: (res) =>
      require(['@/views/useApp/app-course/course-package'], res),
    meta: {
      desc: '课程包',
      title: '课程包',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/app-course/course-list',
    name: 'app-course-course-list',
    component: (res) => require(['@/views/useApp/app-course/course-list'], res),
    meta: {
      keepAlive: true,
      desc: '课程列表',
      title: '课程列表',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/activity/receive-month-card',
    name: 'receive-month-card',
    component: (res) =>
      require(['@/views/activity/receive-month-card/index'], res),
    meta: {
      desc: '赠送月卡',
      title: '赠送月卡'
    }
  },
  {
    path: '/user-sign/index',
    name: 'user-sign-index',
    component: (res) => require(['@/views/useApp/user-sign/index'], res),
    meta: {
      keepAlive: true,
      desc: '新人签到活动',
      title: '新人签到',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/user-sign/prize-list',
    name: 'user-sign-prize-list',
    component: (res) => require(['@/views/useApp/user-sign/prize-list'], res),
    meta: {
      desc: '新人签到活动',
      title: '新人签到',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/user-sign/rule',
    name: 'user-sign-rule',
    component: (res) => require(['@/views/useApp/user-sign/rule'], res),
    meta: {
      desc: '新人签到活动',
      title: '活动规则',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/common-preview-image',
    name: 'common-preview-image',
    component: (res) =>
      require(['@/views/common-preview-image/common-preview-image'], res),
    meta: {
      desc: '',
      title: '',
      webview: {}
    }
  },
  {
    path: '/coupon-package-list',
    name: 'coupon-package-list',
    component: (res) => require(['@/views/weimeng/deep-link'], res),
    meta: {
      desc: '',
      title: '',
      webview: {}
    }
  },
  {
    path: '/dietitian-vote/index',
    name: 'dietitian-vote-index',
    component: (res) => require(['@/views/useApp/dietitian-vote/index'], res),
    meta: {
      desc: '',
      title: '',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/dietitian-vote/rule',
    name: 'dietitian-vote-rule',
    component: (res) => require(['@/views/useApp/dietitian-vote/rule'], res),
    meta: {
      desc: '',
      title: '活动规则',
      webview: {}
    }
  },
  {
    path: '/dietitian-vote/invite',
    name: 'dietitian-vote-invite',
    component: (res) => require(['@/views/useApp/dietitian-vote/invite'], res),
    meta: {
      desc: '',
      title: '邀请好友',
      webview: {}
    }
  },
  {
    path: '/dietitian-vote/vote',
    name: 'dietitian-vote-vote',
    component: (res) => require(['@/views/useApp/dietitian-vote/wx-vote'], res),
    meta: {
      desc: '',
      title: '营养师投票',
      webview: {}
    }
  },
  {
    path: '/dietitian-vote/rank',
    name: 'dietitian-vote-rank',
    component: (res) =>
      require(['@/views/useApp/dietitian-vote/dietitian-rank'], res),
    meta: {
      desc: '',
      title: '营养师投票排行',
      webview: {}
    }
  },
  {
    path: '/join-camp-question',
    name: 'join-camp-question',
    component: (res) =>
      require(['@/views/useBoth/join-camp-question/index'], res),
    meta: {
      keepAlive: true,
      desc: '',
      title: '',
      webview: {}
    }
  },
  {
    path: '/join-camp-question-agreement',
    name: 'join-camp-question-agreement',
    component: (res) =>
      require(['@/views/useBoth/join-camp-question/agreement'], res),
    meta: {
      desc: '',
      title: '',
      webview: {}
    }
  },
  {
    path: '/custom-member-card',
    name: 'custom-member-card',
    component: (res) =>
      require(['@/views/useApp/custom-member-card/index'], res),
    meta: {
      desc: '',
      title: '',
      webview: {
        title: '案例详情'
      }
    }
  },
  /* 营养闹钟 */
  {
    path: '/nutrition-clock/index',
    name: 'nutrition-clock-index',
    component: (res) => require(['@/views/useApp/nutrition-clock/index'], res),
    meta: {
      desc: '',
      title: '营养闹钟',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/nutrition-clock/edit-plan',
    name: 'nutrition-clock-edit-plan',
    component: (res) =>
      require(['@/views/useApp/nutrition-clock/edit-plan'], res),
    meta: {
      desc: '',
      title: '营养闹钟',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/nutrition-clock/select',
    name: 'nutrition-clock-select',
    component: (res) => require(['@/views/useApp/nutrition-clock/select'], res),
    meta: {
      desc: '',
      title: '营养闹钟',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/nutrition-clock/plan-detail',
    name: 'nutrition-clock-plan-detail',
    component: (res) =>
      require(['@/views/useApp/nutrition-clock/plan-detail'], res),
    meta: {
      desc: '',
      title: '营养闹钟',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/nutrition-clock/plan-list',
    name: 'nutrition-clock-plan-list',
    component: (res) =>
      require(['@/views/useApp/nutrition-clock/plan-list'], res),
    meta: {
      keepAlive: true,
      desc: '',
      title: '营养闹钟',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/nutrition-clock/search',
    name: 'nutrition-clock-search',
    component: (res) => require(['@/views/useApp/nutrition-clock/search'], res),
    meta: {
      desc: '',
      title: '营养闹钟',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/wm-jump',
    name: 'wm-jump',
    component: (res) => require(['@/views/weimeng/jump'], res),
    meta: {
      desc: '',
      title: '跳转'
    }
  },
  {
    path: '/app-download',
    name: 'app-download',
    component: (res) => require(['@/views/useApp/app-download/index'], res),
    meta: {
      desc: '',
      title: 'betterWE星球'
    }
  },
  {
    path: '/app-download-test',
    name: 'app-download-test',
    component: (res) => require(['@/views/useApp/app-download/test'], res),
    meta: {
      desc: '',
      title: 'betterWE星球'
    }
  },
  {
    // 综训馆扫码入口页（0928-扫码异常）：外部扫一扫打开会员端 H5（无登录态）后
    // 跳转到本页，引导打开/下载 betterwe星球 APP 并定位综训馆内页（toAppPath 写死在页面内）
    path: '/zxg-scan-entry',
    name: 'zxg-scan-entry',
    component: (res) => require(['@/views/useApp/zxg-scan-entry/index'], res),
    meta: {
      desc: '',
      title: 'betterwe星球综训馆'
    }
  },
  {
    // 我的订单中转页：APP「我的订单」入口，按订单类型分发到
    // 自研商城（/ecShop）、综训馆 H5（/web + token）、微盟商城（/web）
    path: '/my-orders-entry',
    name: 'my-orders-entry',
    component: (res) => require(['@/views/useApp/my-orders-entry/index'], res),
    meta: {
      desc: '',
      title: '我的订单'
    }
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: (res) => require(['@/views/useApp/agreement/index'], res),
    meta: {
      desc: '',
      title: '用户协议'
    }
  },
  {
    path: '/activity/member-sign-in',
    name: 'member-sign-in-page',
    component: (res) => require(['@/views/activity/sign-60-day/home'], res),
    meta: {
      desc: '',
      title: '0元得we+会员年卡',
      keepAlive: true,
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/app-login',
    name: 'app-login',
    component: (res) => require(['@/views/useBoth/register-login/index'], res),
    meta: {
      desc: '',
      title: '登录注册'
    }
  },
  {
    path: '/nutrition-clock/tonic-detail',
    name: 'nutrition-clock-tonic-detail',
    component: (res) =>
      require(['@/views/useApp/nutrition-clock/tonic-detail'], res),
    meta: {
      desc: '',
      title: '补剂详情'
    }
  },
  {
    path: '/brand-introduction',
    name: 'brand-introduction',
    component: () => import('@/views/activity/brand-introduction/index'),
    meta: {
      title: '品牌介绍'
    }
  },
  {
    path: '/newcomer-questionnaire-v2/loading',
    name: 'newcomer-questionnaire-v2-loading',
    component: (res) =>
      require(['@/views/useApp/newcomer-questionnaire-v2/loading'], res),
    meta: {
      desc: '新人专区问卷',
      title: '我的体质评估报告',
      webview: {}
    }
  },
  {
    path: '/activity/betterwe-shopping-festival',
    name: '2024-betterwe-shopping-festival',
    component: (res) =>
      require(['@/views/activity/2024-betterwe-shopping-festival/index'], res),
    meta: {
      desc: 'betterWE购物节',
      title: 'betterWE购物节',
      webview: {}
    }
  },
  {
    path: '/join-camp-question-v2/start',
    name: 'join-camp-question-v2-start',
    component: (res) =>
      require(['@/views/useBoth/join-camp-question-v2/start'], res),
    meta: {
      desc: '',
      title: ''
    }
  },
  {
    path: '/join-camp-question-v2/question',
    name: 'join-camp-question-v2-question',
    component: (res) =>
      require(['@/views/useBoth/join-camp-question-v2/index'], res),
    meta: {
      desc: '',
      title: ''
    }
  },
  {
    path: '/join-camp-question-v2/submit',
    name: 'join-camp-question-v2-submit',
    component: (res) =>
      require(['@/views/useBoth/join-camp-question-v2/submit'], res),
    meta: {
      desc: '',
      title: ''
    }
  },
  {
    path: '/join-camp-question-v2/login',
    name: 'join-camp-question-v2-login',
    component: (res) =>
      require(['@/views/useBoth/join-camp-question-v2/login'], res),
    meta: {
      desc: '',
      title: ''
    }
  },
  {
    path: '/not-camp-review-tool/list',
    name: 'not-camp-review-tool-list',
    component: (res) =>
      require([
        '@/views/useApp/nutritionist-reviews-tool-not-class/index'
      ], res),
    meta: {
      keepAlive: true,
      desc: '',
      title: '非营期餐卡点评',
      webview: {}
    }
  },
  {
    path: '/not-camp-review-tool/detail',
    name: 'not-camp-review-tool-detail',
    component: (res) =>
      require([
        '@/views/useApp/nutritionist-reviews-tool-not-class/detail'
      ], res),
    meta: {
      desc: '',
      title: '非营期餐卡点评',
      webview: {}
    }
  },
  {
    path: '/not-camp-review-tool/tab',
    name: 'not-camp-review-tool-tab',
    component: (res) =>
      require(['@/views/useApp/nutritionist-reviews-tool-not-class/tab'], res),
    meta: {
      desc: '',
      title: '非营期餐卡点评',
      webview: {}
    }
  },
  {
    path: '/app-camp/plan-detail',
    name: 'app-camp-plan-detail',
    component: (res) => require(['@/views/useApp/app-camp/plan-detail'], res),
    meta: {
      keepAlive: true,
      desc: '计划详情',
      title: '计划详情',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/app-camp/customized-recipes',
    name: 'app-camp-customized-recipes',
    component: (res) =>
      require(['@/views/useApp/app-camp/customized-recipes'], res),
    meta: {
      desc: '定制食谱',
      title: '定制食谱',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/app-camp/nutritionist-detail',
    name: 'app-camp-nutritionist-detail',
    component: (res) =>
      require(['@/views/useApp/app-camp/nutritionist-detail'], res),
    meta: {
      keepAlive: true,
      desc: '营养师详情',
      title: '',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/jump-work-weixin',
    name: 'jump-work-weixin',
    component: (res) => require(['@/views/useApp/jump-work-weixin/index'], res),
    meta: {
      keepAlive: true,
      desc: '跳转企业微信',
      title: '',
      webview: {}
    }
  },
  {
    path: '/nutritionist-training-program/index',
    name: 'nutritionist-training-program-index',
    component: (res) =>
      require(['@/views/activity/nutritionist-training-program/index'], res),
    meta: {
      keepAlive: true,
      desc: '公共营养师培养计划',
      title: '',
      webview: {}
    }
  },
  {
    path: '/nutritionist-training-program/add-customer',
    name: 'nutritionist-training-program-add-customer',
    component: (res) =>
      require([
        '@/views/activity/nutritionist-training-program/add-customer'
      ], res),
    meta: {
      keepAlive: true,
      desc: '公共营养师培养计划',
      title: '',
      webview: {}
    }
  },
  {
    path: '/join-camp-question-v2/course-agreement',
    name: 'join-camp-question-v2-course-agreement',
    component: (res) =>
      require(['@/views/useBoth/join-camp-question-v2/course-agreement'], res),
    meta: {
      desc: '课程协议',
      title: '',
      webview: {}
    }
  },
  {
    path: '/sms',
    name: 'sms',
    component: (res) => require(['@/views/activity/sms-jump/index'], res),
    meta: {
      desc: '短信跳转中转页',
      title: '',
      webview: {}
    }
  },
  {
    path: '/activity/receive-week-card',
    name: 'receive-week-card',
    component: (res) =>
      require(['@/views/activity/receive-week-card/index'], res),
    meta: {
      desc: '赠送周卡',
      title: '赠送周卡'
    }
  },
  /* 减脂营转介绍v4版本 */
  {
    path: '/camp-invite-v4/index',
    name: 'camp-invite-v4-index',
    component: (res) =>
      require(['@/views/activity/camp-introduce-v4/invite'], res),
    meta: {
      desc: '老会员邀请好友界面',
      title: 'betterWE减脂营',
      webview: {
        title: 'betterWE减脂营',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/camp-invite-v4/detail',
    name: 'camp-invite-v4-detail',
    component: (res) =>
      require(['@/views/activity/camp-introduce-v4/invite-detail'], res),
    meta: {
      desc: '老会员邀请好友界面',
      title: 'betterWE减脂营',
      webview: {
        title: 'betterWE减脂营',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/camp-invite-v4/invite',
    name: 'camp-invite-v4-invite',
    component: (res) =>
      require(['@/views/activity/camp-introduce-v4/wx-invite'], res),
    meta: {
      desc: '老会员邀请好友界面',
      title: 'betterWE减脂营',
      webview: {
        title: 'betterWE减脂营',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/activity/comment-incoming-line',
    name: 'activity-comment-incoming-line',
    component: (res) =>
      require(['@/views/activity/comment-incoming-line/index'], res),
    meta: {
      desc: '分流进线页',
      title: '',
      webview: {}
    }
  },
  {
    path: '/activity/vip-preferential',
    name: 'vip-preferential',
    component: (res) =>
      require(['@/views/activity/year-card-vip-99/index'], res),
    meta: {
      keepAlive: true,
      desc: '特惠年卡',
      title: '',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/mango-h5',
    name: 'mango-h5',
    component: (res) => require(['@/views/activity/mango-h5/index'], res),
    meta: {
      title: '芒果优惠码绑定'
    }
  },
  {
    path: '/receive-vip-coupon',
    name: 'receive-vip-coupon',
    component: (res) =>
      require(['@/views/useApp/receive-vip-coupon/index'], res),
    meta: {
      keepAlive: true,
      desc: '领取vip优惠券',
      title: 'WE+会员专属优惠券',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/activity/member-sign-in/record',
    name: 'member-sign-in-record',
    component: (res) => require(['@/views/activity/sign-60-day/record'], res),
    meta: {
      title: '签到打卡记录',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/activity/jianmeng-experience-card',
    name: 'jianmeng-experience-card',
    component: (res) =>
      require(['@/views/activity/jianmeng-experience-card/index'], res),
    meta: {
      title: '健萌体验卡',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/activity/2024/coach-flower-giving-activity',
    name: 'jianmeng-coach-vote-2024',
    component: (res) =>
      require(['@/views/activity/jianmeng-coach-vote-2024/index'], res),
    meta: {
      title: '健萌教练活动',
      keepAlive: true,
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/activity/2024/store-detail',
    name: 'jianmeng-store-detail',
    component: (res) =>
      require(['@/views/activity/jianmeng-coach-vote-2024/store-detail'], res),
    meta: {
      title: '门店详情',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/activity/2024/jianmeng-coach-vote/city-rank',
    name: 'jianmeng-coach-vote-city-rank',
    component: (res) =>
      require(['@/views/activity/jianmeng-coach-vote-2024/rank-changsha'], res),
    meta: {
      title: '长沙最用心教练评选排行榜',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/members-stories',
    name: 'members-stories',
    component: (res) => require(['@/views/useApp/members-stories/index'], res),
    meta: {
      desc: '会员故事',
      title: 'W会员故事',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/activity/spring-festival-course-reservation',
    name: 'spring-festival-course-reservation',
    component: (res) =>
      require([
        '@/views/activity/2025/spring-festival-course-reservation/spring-festival-course-reservation'
      ], res),
    meta: {
      desc: '新春约课活动',
      title: '新春约课活动',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  /* 通用h5打开app中转 */
  {
    path: '/sfcr',
    name: 'sfcr',
    component: (res) => require(['@/views/sms/index.vue'], res),
    meta: {
      desc: '',
      title: '',
      webview: {}
    }
  },
  {
    path: '/activity/20250308/happy-goddess-festival',
    name: '20250308-happy-goddess-festival',
    component: (res) =>
      require([
        '@/views/activity/2025/03-08-happy-goddess-festival/03-08-happy-goddess-festival.vue'
      ], res),
    meta: {
      desc: '',
      title: '女神节快乐',
      webview: {
        isTransparentBottomBar: 1
      }
    }
  },
  {
    path: '/app-error',
    name: 'app-error',
    component: (res) => require(['@/views/error/error.vue'], res),
    meta: {
      desc: '错误',
      title: '错误',
      webview: {}
    }
  },
  {
    path: '/member-invitation',
    name: 'member-invitation',
    component: (res) =>
      require([
        '@/views/activity/2025/05-22-beijing-invitation/05-22-beijing-invitation.vue'
      ], res),
    meta: {
      desc: '健萌健身北京概念店邀请函',
      title: '健萌健身北京概念店邀请函',
      webview: {}
    }
  },
  {
    path: '/aliyun-captcha',
    name: 'aliyun-captcha',
    component: (res) =>
      require(['@/views/useApp/aliyun-captcha/aliyun-captcha.vue'], res),
    meta: {
      desc: '验证码',
      title: '验证码',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/wegymer-consult-wx',
    name: 'wegymer-consult-wx',
    component: (res) =>
      require(['@/views/useApp/consult-us/wegymer-consult-us.vue'], res),
    meta: {
      desc: '',
      title: '健萌客服',
      webview: {
        isTransparentBottomBar: 1
      }
    }
  },
  {
    path: '/gym-nutrition-hotspots',
    name: 'gym-nutrition-hotspots',
    component: (res) =>
      require(['@/views/useApp/nutrition-hotspots/gym.vue'], res),
    meta: {
      desc: '',
      title: '',
      webview: {
        toolsBarBgColor: '#00000000',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        titleColor: '#ffffff',
        isShowToolsBar: false
      }
    }
  },
  {
    path: '/get-token',
    name: 'gym-exchange-betterwe-token',
    component: (res) =>
      require([
        '@/views/gym-exchange-betterwe-token/gym-exchange-betterwe-token.vue'
      ], res),
    meta: {
      desc: '',
      title: '',
      webview: {}
    }
  },
  {
    path: '/meal-detail/:mealCardId',
    name: 'meal-detail',
    component: () => import('@/views/meal-card-review-system/meal-detail.vue'),
    meta: {
      title: '餐卡详情',
      desc: '查看餐卡详细信息',
      requiresAuth: false,
      hidden: true
    }
  },
  ...businessCenterRouter, //加载明星减脂营的router
  // 上传餐卡页面（小程序 WebView 入口）
  {
    path: '/meal-upload',
    name: 'meal-upload',
    component: () => import('@/views/meal-card-review-system/meal-upload.vue'),
    meta: {
      title: '上传餐卡',
      requiresAuth: false,
      hidden: true
    }
  },
  // 历史餐卡页面（小程序 WebView 入口）
  {
    path: '/meal-history',
    name: 'meal-history',
    component: () => import('@/views/meal-card-review-system/meal-history.vue'),
    meta: {
      title: '历史餐卡',
      requiresAuth: false,
      hidden: true,
      keepAlive: true
    }
  },
  // 餐卡点评列表
  {
    path: '/meal-review-list',
    name: 'meal-review-list',
    component: () =>
      import('@/views/meal-card-review-system/meal-review-list.vue'),
    meta: {
      title: '餐卡点评列表',
      desc: '餐卡点评列表',
      requiresAuth: true,
      hidden: true
    }
  },
  // 班级餐卡页面（营养师专用）
  {
    path: '/meal-class/:classId',
    name: 'meal-class',
    component: () => import('@/views/meal-card-review-system/meal-class.vue'),
    meta: {
      title: '班级餐卡',
      desc: '查看班级餐卡点评信息',
      requiresAuth: true,
      hidden: true
    }
  },
  // 点评编辑页面（营养师专用）
  {
    path: '/meal-review/:mealCardId',
    name: 'meal-review',
    component: () => import('@/views/meal-card-review-system/meal-review.vue'),
    meta: {
      title: '点评编辑',
      desc: '编辑餐卡点评内容',
      requiresAuth: true,
      hidden: true
    }
  },
  // 综训馆开业转介绍-老会员邀请页
  {
    path: '/zx-referral/old-member',
    name: 'ZxReferralOldMember',
    component: (res) =>
      require(['@/views/activity/zongxun-referral/old-member'], res),
    meta: {
      desc: '综训馆开业转介绍-老会员邀请',
      title: '邀好友·开业转介',
      webview: {
        title: '邀好友·开业转介',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        isShowToolsBar: false
      }
    }
  },
  // 综训馆开业转介绍-新会员领取页
  {
    path: '/zx-referral/new-member',
    name: 'ZxReferralNewMember',
    component: (res) =>
      require(['@/views/activity/zongxun-referral/new-member'], res),
    meta: {
      desc: '综训馆开业转介绍-新会员领取',
      title: '邀你一起训练',
      webview: {
        title: '邀你一起训练',
        statusColor: '#00000000',
        isTransparentBottomBar: 1,
        isShowToolsBar: false
      }
    }
  },
  // 综训馆开业转介绍-协议详情（按 code 取单条协议内容，列表接口已带 content）
  {
    path: '/zx-referral/covenant-detail',
    name: 'ZxReferralCovenantDetail',
    // prettier-ignore
    component: (res) =>
      require(['@/views/activity/zongxun-referral/ponents/CovenantDetail'], res),
    meta: {
      desc: '综训馆开业转介绍-协议详情',
      title: '用户协议'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})

/**
 * 路由前置检查
 */
router.beforeEach(beforeEachFunction)
export default router
